import './card-study.scss';

export default () => {

};
